/**
 * className 合并。
 *
 * `clsx` 负责条件拼接，`tailwind-merge` 负责**后写的冲突类覆盖先写的** ——
 * 没有它，`cn('px-4', 'px-2')` 会两个都留着，最终由 CSS 源码顺序决定谁生效，
 * 于是组件的 className 覆写时灵时不灵。
 */
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
